export default "__VITE_ASSET__DGVCSiov__"